/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Link_Social_LoginsInputs */

const en_profile_link_social_logins = /** @type {(inputs: Profile_Link_Social_LoginsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Social Logins`)
};

const es_profile_link_social_logins = /** @type {(inputs: Profile_Link_Social_LoginsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vincular inicios de sesión sociales`)
};

/**
* | output |
* | --- |
* | "Link Social Logins" |
*
* @param {Profile_Link_Social_LoginsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const profile_link_social_logins = /** @type {((inputs?: Profile_Link_Social_LoginsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Link_Social_LoginsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_profile_link_social_logins(inputs)
	return en_profile_link_social_logins(inputs)
});